export default __webpack_public_path__ + "static/media/nu.19a7eb70.svg";